import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_provide_workers_free_potable_drinking_water'

export const dataPointDefinition = {
  retracedId: 'does_facility_provide_workers_free_potable_drinking_water',
  name: 'Does the facility provide workers with free, potable drinking water, although there are no applicable legal requirements',
  description: 'You have indicated that there are "No applicable legal requirements". ',
  meta: {
    slcpMeta: {
      key: 'hs-6',
      number: 'HS-GEN-33',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-6', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29420,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
